import { Driver, Method } from 'shared/types/marketplace';
import { FEES } from 'shared/types/marketplacePayment';

type FeeOption = {
  selection: string;
  fee: FEES;
  transactionFeeValue: number;
  transactionFeeType: Method['transactionFeeType'];
};

const FEE_OPTIONS: FeeOption[] = [
  {
    selection: '1',
    fee: FEES.UM_REAL,
    transactionFeeValue: 1,
    transactionFeeType: 'VALUE',
  },
  {
    selection: '2',
    fee: FEES.VINTE_CENTAVOS,
    transactionFeeValue: 0.2,
    transactionFeeType: 'VALUE',
  },
  {
    selection: '3',
    fee: FEES.NOVENTA_CENTAVOS,
    transactionFeeValue: 0.9,
    transactionFeeType: 'VALUE',
  },
  {
    selection: '4',
    fee: FEES.SESSENTA_CENTAVOS,
    transactionFeeValue: 0.6,
    transactionFeeType: 'VALUE',
  },
  {
    selection: '5',
    fee: FEES.DOIS_REAIS_E_DEZ,
    transactionFeeValue: 2.1,
    transactionFeeType: 'PERCENTAGE',
  },
  {
    selection: '6',
    fee: FEES.DOIS_REAIS,
    transactionFeeValue: 2,
    transactionFeeType: 'VALUE',
  },
  {
    selection: '7',
    fee: FEES.UM_REAL_E_CINQUENTA,
    transactionFeeValue: 1.5,
    transactionFeeType: 'VALUE',
  },
  {
    selection: '8',
    fee: FEES.UM_E_CINQUENTA,
    transactionFeeValue: 1.5,
    transactionFeeType: 'PERCENTAGE',
  },
  {
    selection: '9',
    fee: FEES.DOIS_PCT,
    transactionFeeValue: 0,
    transactionFeeType: 'VALUE',
  },
];

const getMatchingOption = (method: Method): FeeOption | undefined => {
  if (!method.enabled) return undefined;

  return FEE_OPTIONS.find(
    (option) =>
      option.transactionFeeValue === method.transactionFeeValue &&
      option.transactionFeeType === method.transactionFeeType,
  );
};

export const getSelectionValueFromDriver = (driver?: Driver | null): string => {
  const method = driver?.methods?.[0];
  if (!method) return '1';

  return getMatchingOption(method)?.selection ?? '1';
};

export const getFeesFromSelectionValue = (selection: string): FEES[] => {
  const option = FEE_OPTIONS.find(
    (feeOption) => feeOption.selection === selection,
  );
  return option ? [option.fee] : [];
};

export const getFeesFromDriver = (driver?: Driver | null): FEES[] => {
  const selection = getSelectionValueFromDriver(driver);
  return getFeesFromSelectionValue(selection);
};
